<script setup>
  const props = defineProps(['events', 'firstSection']);
  const { events, firstSection } = props;
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap wide :class="{ firstSection }">
    <BigTitle h1>
      <slot />
    </BigTitle>
    <Foreground>
      <div class="events">
        <PastEventCard v-for="event in events" :event="event" />
      </div>
    </Foreground>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    padding-top: px(90);
    padding-bottom: px(128);
    margin-bottom: -$content-padding-bottom;

    background-color: $black;

    .foreground {
      @include break-min-large {
        @include column(2, 11);
      }
    }

    &.firstSection {
      @include top-padding;
    }

    .events {
      display: flex;
      flex-direction: column;

      gap: px(48);
    }

    @include break-medium {
      .events {
        gap: $margin-medium;
      }
    }

    @include break-small {
      .events {
        gap: $margin-small;
      }
    }

    @include break-phone {
      .events {
        gap: px(32);
      }
    }
  }
</style>
